import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { DacService } from '../dac.service';
import { DynamicDocCopy } from '@/types';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DataTableRowActions } from '@/components/data-table-builder/data-table.types';
import { getDacEditDynamicDocsCopyDataTableStructure } from './utils/dac-edit-dynamic-docs-copy.datatable-object';
import { getDynaCopyUploadDialog } from './utils/dac-edit-dynamic-docs-copy.upload-dialog-object';
import { DialogComponent } from '@/components/dialog/dialog.component';
import { DialogObject } from '@/components/dialog/dialog.types';
import { fileUtils } from '@/utils/file.utils';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sm-dac-edit-dynamic-docs-copy',
  imports: [DataTableBuilderComponent, DialogComponent],
  templateUrl: './dac-edit-dynamic-docs-copy.component.html',
  styleUrl: './dac-edit-dynamic-docs-copy.component.scss',
})
export class DacEditDynamicDocsCopyComponent implements OnInit {
  dacService = inject(DacService);
  messageService = inject(MessageService);
  @Input() dacId?: number;
  @Input() dacVer?: number;

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  uploadDialogObject?: DialogObject;
  uploadFile$ = new BehaviorSubject<File[]>([]);

  rowActionsFn: (target: DynamicDocCopy) => DataTableRowActions = (target: DynamicDocCopy) => {
    return {
      additionalActions: {
        download: [
          {
            icon: 'pi pi-download',
            label: 'dac.dacDynamicDocCopy.actions.download',
            action: () => {
              this.download(target);
            },
          },
        ],
        upload: [
          {
            icon: 'pi pi-upload',
            label: 'dac.dacDynamicDocCopy.actions.upload',
            action: () => {
              this.upload(target);
            },
          },
        ],
      },
    };
  };

  data: DynamicDocCopy[] = [];
  datatableObject = getDacEditDynamicDocsCopyDataTableStructure({
    rowActionsFn: (target: DynamicDocCopy) => this.rowActionsFn(target),
  });
  loading = false;

  ngOnInit() {
    this.loading = true;
    this.dacService.getAllActiveLastCopies({ dacId: this.dacId!, dacVer: this.dacVer! }).subscribe(data => {
      this.data = data;
      this.loading = false;
    });
  }

  download(target: DynamicDocCopy) {
    this.dacService.downloadModified(target.id).subscribe(blob => {
      fileUtils.triggerBlobDownload(blob, `${target.name}.docx`);
    });
  }

  upload(target: DynamicDocCopy) {
    this.uploadFile$.next([]);
    this.uploadDialogObject = getDynaCopyUploadDialog({
      file$: this.uploadFile$,
      validate: () => {
        const files = this.uploadFile$.getValue();
        if (files.length === 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Fichier manquant',
            detail: 'Veuillez sélectionner un fichier',
          });
          return;
        }

        const formData = new FormData();
        formData.append('file', files[0]);

        this.dacService.uploadModified(target.id, formData).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Succès',
              detail: 'Le document a été téléversé avec succès',
            });
            this.dialogComponent.toggleVisible();
            this.ngOnInit();
          },
          error: error => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erreur',
              detail: error?.error?.message || 'Une erreur est survenue',
            });
          },
        });
      },
    });
    this.dialogComponent.toggleVisible();
  }
}
